import React, { Component } from 'react';

const $= window.$;


class Mentorhistory extends Component {
	constructor(props) {
		super(props);
		

		
	}

		render() {

        	const {mentorhistory} = this.props;
       
			 let rows = mentorhistory.map((mentor,i) => {
                return (
		                   <tr key={i}>
			                   	<td>{i+1}</td>
				                <td>{mentor.name}</td>
				                <td>{mentor.email}</td>
				                <td>{mentor.visits}</td>
				                <td>{mentor.tendays}</td>
		                   </tr> 
		                )
		       });

			 (rows.length == 0) ? rows = <tr align="center"><td colSpan="5">No Observers Found.</td></tr> : rows = rows

			return (
				 <div className="mentor_table">
					<table  border="0" width="100%" className="myjourney-table">
                        <thead>
                            <tr>
                                <th>SNo</th>
                                <th>Observer Name</th>
                                <th>Email ID</th>
                                <th>Total visits</th>
                                <th>Visits in last 10 days</th>
                            </tr>
                        </thead>

					  	<tbody>
					  		{rows}
					  	</tbody>
					</table>
				</div>
			);
		}
}

export default Mentorhistory;



// WEBPACK FOOTER //
// ./src/personal_interactions/observer/Mentorhistory.js